/* GENERATED BY tools/gen_web_loyalty.py - DO NOT EDIT.
 *
 * The hero loyalty wheel, transcribed from Revival.Core's HeroDeckbuildingRules.GetLoyalty.
 * It is what makes deck building a decision: a card's realm is scored against your HERO's
 * realm, which changes what it COSTS and can forbid it outright.
 *
 *   Alliance  +0 foxfire      Tolerated +1      Hostile +2      Nemesis: cannot be included
 *
 * Symmetric and closed: each realm has exactly one Tolerated, one Hostile, one Nemesis.
 */
export type Loyalty = "Alliance" | "Tolerated" | "Hostile" | "Nemesis";

/** hero realm -> card realm -> loyalty. Anything unlisted is Alliance. */
export const LOYALTY: Readonly<Record<string, Readonly<Record<string, Loyalty>>>> =
  Object.freeze({
    "The_Verdant_Hollow": Object.freeze({"Domain_of_Negafook": "Tolerated", "The_Scorched_Expanse": "Hostile", "The_Spirit_Veil": "Nemesis"}),
    "Domain_of_Negafook": Object.freeze({"The_Scorched_Expanse": "Nemesis", "The_Spirit_Veil": "Hostile", "The_Verdant_Hollow": "Tolerated"}),
    "The_Spirit_Veil": Object.freeze({"Domain_of_Negafook": "Hostile", "The_Scorched_Expanse": "Tolerated", "The_Verdant_Hollow": "Nemesis"}),
    "The_Scorched_Expanse": Object.freeze({"Domain_of_Negafook": "Nemesis", "The_Spirit_Veil": "Tolerated", "The_Verdant_Hollow": "Hostile"}),
  });

/** Extra lava a card costs at each loyalty. From GetLavaPenalty. */
export const LOYALTY_PENALTY: Readonly<Record<Loyalty, number>> = Object.freeze({
  Alliance: 0,
  Tolerated: 1,
  Hostile: 2,
  Nemesis: 0,
});
